/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Giveawaystats_Loading1Inputs */

const id_components_giveawaystats_loading1 = /** @type {(inputs: Components_Giveawaystats_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat...`)
};

const ms_components_giveawaystats_loading1 = /** @type {(inputs: Components_Giveawaystats_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat...`)
};

const da_components_giveawaystats_loading1 = /** @type {(inputs: Components_Giveawaystats_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indlæser...`)
};

const de_components_giveawaystats_loading1 = /** @type {(inputs: Components_Giveawaystats_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lädt...`)
};

const en_us2_components_giveawaystats_loading1 = /** @type {(inputs: Components_Giveawaystats_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading...`)
};

const es_es2_components_giveawaystats_loading1 = /** @type {(inputs: Components_Giveawaystats_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando...`)
};

const es_mx2_components_giveawaystats_loading1 = /** @type {(inputs: Components_Giveawaystats_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando...`)
};

const fil_components_giveawaystats_loading1 = /** @type {(inputs: Components_Giveawaystats_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naglo-load...`)
};

const fr_components_giveawaystats_loading1 = /** @type {(inputs: Components_Giveawaystats_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement…`)
};

const it_components_giveawaystats_loading1 = /** @type {(inputs: Components_Giveawaystats_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento...`)
};

const hu_components_giveawaystats_loading1 = /** @type {(inputs: Components_Giveawaystats_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betöltés...`)
};

const nl_components_giveawaystats_loading1 = /** @type {(inputs: Components_Giveawaystats_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laden...`)
};

const no_components_giveawaystats_loading1 = /** @type {(inputs: Components_Giveawaystats_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laster...`)
};

const pl_components_giveawaystats_loading1 = /** @type {(inputs: Components_Giveawaystats_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ładowanie...`)
};

const pt_br2_components_giveawaystats_loading1 = /** @type {(inputs: Components_Giveawaystats_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading...`)
};

const pt_components_giveawaystats_loading1 = /** @type {(inputs: Components_Giveawaystats_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A carregar...`)
};

const ro_components_giveawaystats_loading1 = /** @type {(inputs: Components_Giveawaystats_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se încarcă...`)
};

const fi_components_giveawaystats_loading1 = /** @type {(inputs: Components_Giveawaystats_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladataan...`)
};

const sv_components_giveawaystats_loading1 = /** @type {(inputs: Components_Giveawaystats_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laddar...`)
};

const vi_components_giveawaystats_loading1 = /** @type {(inputs: Components_Giveawaystats_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tải...`)
};

const tr_components_giveawaystats_loading1 = /** @type {(inputs: Components_Giveawaystats_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yükleniyor...`)
};

const cs_components_giveawaystats_loading1 = /** @type {(inputs: Components_Giveawaystats_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Načítání...`)
};

const bg_components_giveawaystats_loading1 = /** @type {(inputs: Components_Giveawaystats_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зареждане...`)
};

const ru_components_giveawaystats_loading1 = /** @type {(inputs: Components_Giveawaystats_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка...`)
};

const uk_components_giveawaystats_loading1 = /** @type {(inputs: Components_Giveawaystats_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завантаження...`)
};

const ar_components_giveawaystats_loading1 = /** @type {(inputs: Components_Giveawaystats_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ التحميل...`)
};

const hi_components_giveawaystats_loading1 = /** @type {(inputs: Components_Giveawaystats_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लोड हो रहा है...`)
};

const th_components_giveawaystats_loading1 = /** @type {(inputs: Components_Giveawaystats_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังโหลด...`)
};

const ja_components_giveawaystats_loading1 = /** @type {(inputs: Components_Giveawaystats_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み込み中...`)
};

const zh_cn2_components_giveawaystats_loading1 = /** @type {(inputs: Components_Giveawaystats_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading...`)
};

const zh_hant1_components_giveawaystats_loading1 = /** @type {(inputs: Components_Giveawaystats_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading...`)
};

const ko_components_giveawaystats_loading1 = /** @type {(inputs: Components_Giveawaystats_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading...`)
};

/**
* | output |
* | --- |
* | "Loading..." |
*
* @param {Components_Giveawaystats_Loading1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_giveawaystats_loading1 = /** @type {((inputs?: Components_Giveawaystats_Loading1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Giveawaystats_Loading1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_giveawaystats_loading1(inputs)
	if (locale === "ms") return ms_components_giveawaystats_loading1(inputs)
	if (locale === "da") return da_components_giveawaystats_loading1(inputs)
	if (locale === "de") return de_components_giveawaystats_loading1(inputs)
	if (locale === "en-US") return en_us2_components_giveawaystats_loading1(inputs)
	if (locale === "es-ES") return es_es2_components_giveawaystats_loading1(inputs)
	if (locale === "es-MX") return es_mx2_components_giveawaystats_loading1(inputs)
	if (locale === "fil") return fil_components_giveawaystats_loading1(inputs)
	if (locale === "fr") return fr_components_giveawaystats_loading1(inputs)
	if (locale === "it") return it_components_giveawaystats_loading1(inputs)
	if (locale === "hu") return hu_components_giveawaystats_loading1(inputs)
	if (locale === "nl") return nl_components_giveawaystats_loading1(inputs)
	if (locale === "no") return no_components_giveawaystats_loading1(inputs)
	if (locale === "pl") return pl_components_giveawaystats_loading1(inputs)
	if (locale === "pt-BR") return pt_br2_components_giveawaystats_loading1(inputs)
	if (locale === "pt") return pt_components_giveawaystats_loading1(inputs)
	if (locale === "ro") return ro_components_giveawaystats_loading1(inputs)
	if (locale === "fi") return fi_components_giveawaystats_loading1(inputs)
	if (locale === "sv") return sv_components_giveawaystats_loading1(inputs)
	if (locale === "vi") return vi_components_giveawaystats_loading1(inputs)
	if (locale === "tr") return tr_components_giveawaystats_loading1(inputs)
	if (locale === "cs") return cs_components_giveawaystats_loading1(inputs)
	if (locale === "bg") return bg_components_giveawaystats_loading1(inputs)
	if (locale === "ru") return ru_components_giveawaystats_loading1(inputs)
	if (locale === "uk") return uk_components_giveawaystats_loading1(inputs)
	if (locale === "ar") return ar_components_giveawaystats_loading1(inputs)
	if (locale === "hi") return hi_components_giveawaystats_loading1(inputs)
	if (locale === "th") return th_components_giveawaystats_loading1(inputs)
	if (locale === "ja") return ja_components_giveawaystats_loading1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_giveawaystats_loading1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_giveawaystats_loading1(inputs)
	return ko_components_giveawaystats_loading1(inputs)
});
export { components_giveawaystats_loading1 as "components.giveawayStats.loading" }